import { Footer } from "../components/Footer";
import Header from "../components/Header";
import { Section } from "../components/Section";


export default function TOS({}) {
    return  <div >
    <div className="gradientBG">
        <Header title="Privacy Policy of Chatmate AI"/>
        <Section placeItems="" className=" px-0 pb-8 gap-4 flex-col flex">

            <div className="text-5xl py-10">Privacy Policy</div>

            <div>Last updated: February 11, 2023</div>

            <div clasName="py-4">Welcome to Chatmate AI, a virtual companion app offered by BENPIRE GmbH. This Privacy Policy sets out how BENPIRE GmbH collects, uses, and discloses personal information through the use of our app.</div>

            <div className="text-3xl">Information Collection</div>
            <div>When you use Chatmate AI, we may collect personal information such as your name, age, gender, and location. We also collect information about your use of our app, such as the messages you send and receive through the app.</div>

            <div className="text-3xl">Use of Personal Information</div>
            <div>We use the personal information we collect through Chatmate AI to provide and improve our app, to communicate with you, and to comply with legal obligations.</div>

            <div className="text-3xl">Disclosure of Personal Information</div>
            <div>We will not disclose your personal information to third parties except as required by law or to provide and improve our app. We may share aggregated or anonymized information with third parties for research or marketing purposes.</div>

            <div className="text-3xl">Security of Personal Information</div>
            <div>We take reasonable measures to protect the personal information we collect through Chatmate AI from unauthorized access, use, or disclosure. However, we cannot guarantee the security of personal information and you use our app at your own risk.</div>

            <div className="text-3xl">International Transfer</div>
            <div>Your personal information may be transferred to and processed in countries other than your country of residence. These countries may have different data protection laws than your country of residence.</div>

            <div className="text-3xl">Access to Personal Information</div>
            <div>You have the right to access and request the correction of any personal information we have collected about you. To exercise this right, please contact us at [insert contact information].</div>

            <div className="text-3xl">Changes to This Privacy Policy</div>
            <div>We may make changes to this Privacy Policy at any time. Your continued use of Chatmate AI after any changes have been made constitutes your acceptance of the revised Privacy Policy.</div>

            <div>By using Chatmate AI, you acknowledge that you have read and understood this Privacy Policy and agree to the collection, use, and disclosure of your personal information as described herein. If you have any questions or concerns about this Privacy Policy, please contact us at email@holomate.io.</div>

            <div className="font-bold py-4 text-3xl">Thank you for using Chatmate AI!</div>
            
        </Section>
    </div>
    <Footer/>
</div>
}